var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_184",
    "data-name": "Ret\\xE2ngulo 184",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elo",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elo-2",
    "data-name": "elo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_1",
    "data-name": "Uni\\xE3o 1",
    d: "M-9997.559-5968.069l.848-2.541a3.733,3.733,0,0,0,1.2.2,3.828,3.828,0,0,0,3.75-3.057l2.617.536a6.5,6.5,0,0,1-6.369,5.2,6.6,6.6,0,0,1-2.049-.339Zm19.6-1.839a1.472,1.472,0,0,1-.643-.542,1.716,1.716,0,0,1-.254-.942v-7.618h1.689v7.6l1.18.479-.672,1.569Zm-24.031-4.328a6.5,6.5,0,0,1,2.2-4.87l1.771,2a3.81,3.81,0,0,0-1.291,2.861,3.807,3.807,0,0,0,1.291,2.864l-1.773,2a6.5,6.5,0,0,1-2.207-4.848Zm28.771,4.653.578-1.722a2.045,2.045,0,0,0,.68.115,2.159,2.159,0,0,0,2.117-1.717l1.771.36a3.961,3.961,0,0,1-3.887,3.168,4.014,4.014,0,0,1-1.277-.189Zm-11.738-.1a3.73,3.73,0,0,1-.727-.4l.91-1.371.053-.074a1.9,1.9,0,0,0,2.086.209,2.071,2.071,0,0,0,.971-.815l.078.049,1.4.93a3.759,3.759,0,0,1-1.709,1.418,3.96,3.96,0,0,1-1.588.346,3.761,3.761,0,0,1-1.477-.277Zm9.035-3.66a3.954,3.954,0,0,1,1.338-2.971l1.215,1.352a2.154,2.154,0,0,0-.744,1.621,2.144,2.144,0,0,0,.738,1.62l-1.2,1.349a3.929,3.929,0,0,1-1.361-2.954Zm-11.176,1.535a3.873,3.873,0,0,1-.084-2.919,3.861,3.861,0,0,1,2.072-2.266,4.008,4.008,0,0,1,3.668.267,3.924,3.924,0,0,1,1.633,1.974c.053.119.092.245.141.347l-7.158,3.12a4.019,4.019,0,0,1-.273-.522Zm2.664-3.632a1.97,1.97,0,0,0-1.2,2.091l3.6-1.549a1.9,1.9,0,0,0-1.477-.751,2.3,2.3,0,0,0-.928.222Zm12.48-.057a2.1,2.1,0,0,0-.687.114l-.568-1.721a3.949,3.949,0,0,1,1.262-.2,3.968,3.968,0,0,1,3.883,3.184l-1.779.358a2.162,2.162,0,0,0-2.115-1.722Zm-23.531-2.56a3.742,3.742,0,0,0-1.215.2l-.852-2.542a6.618,6.618,0,0,1,2.064-.331,6.509,6.509,0,0,1,6.371,5.2l-2.623.536a3.832,3.832,0,0,0-3.76-3.055Z",
    transform: "translate(10014.004 5994.727)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.fa88862220773f2bbd7164ebb01e0530.svg";
export { ForwardRef as ReactComponent };